module.exports = __webpack_public_path__ + "static/img/bannerWithPuzzle_ba.599a73fc.png";